import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError(err => {
				let error = err?.error?.message || err?.statusText;
				const errorStatus = err?.status || err?.statusCode;

				if (errorStatus > 399 && request.headers.has(InterceptorSkipHeader)) {
					request.headers.delete(InterceptorSkipHeader);
					return throwError(() => err?.error);
				}

				if (err?.error?.messageDetails) {
					const { messageDetails } = err?.error;
					if (Array.isArray(messageDetails)) {
						error = messageDetails.reduce((acc, curr) => {
							return acc + ` ${curr.message}.`;
						}, '');
					}
				}

				if ([400, 401, 404].includes(errorStatus)) {
					Sentry.captureMessage(`${request.url} has failed with ${err.status}`);
					Sentry.captureException(err.error);
				}

				if (errorStatus >= 500) {
					Sentry.captureException(`${request.url} has failed with ${err.status} ${errorStatus} ${error}`, {
						level: 'fatal',
						extra: {
							error: error,
							status: err?.status,
							statusCode: err?.statusCode,
							url: request.url,
							body: request.body,
							method: request.method,
							headers: request.headers,
						},
					});
					Sentry.captureException(err.error);
				}

				throw err;
			})
		);
	}
}
